/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { message } from 'antd';
import { captureException } from '@sentry/browser';
import { intl } from '../../providers/IntlProvider';
import { AttachmentDeleteParams } from '../../models/attachments';
import DeleteIcon from '../../assets/icon-delete-white.svg';
import CloseIcon from '../../assets/close-icon-mobile-white.svg';
import DownloadIcon from '../../assets/icon-download-white.svg';
import { fetchImage } from '../../services/api';
import styles from './fileViewer.module.less';

interface DownloadButtonProps {
  fileId: string;
  fileName: string;
}

export const DownloadButton = ({ fileId, fileName }: DownloadButtonProps): JSX.Element => {
  const handleDownload = async (event: React.MouseEvent<HTMLButtonElement>): Promise<object | null> => {
    event.preventDefault();

    try {
      const fileBlob = await fetchImage(fileId);
      const url = URL.createObjectURL(fileBlob);
      const link = document.createElement('a');

      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      captureException(error);
      message.error(intl.formatMessage({ id: 'message.downloadFail' }));
      return null;
    }
  };

  return (
    <button type="button" className={styles.downloadButton} onClick={handleDownload}>
      <img src={DownloadIcon} alt="download button" />
    </button>
  );
};

interface DeleteButtonProps {
  handleDeleteClick: (params: AttachmentDeleteParams) => void;
  allowDelete: boolean;
  id?: string;
  name?: string;
}

export const DeleteButton = ({ handleDeleteClick, allowDelete, id, name }: DeleteButtonProps): JSX.Element =>
  (allowDelete && (id || name) && (
    <button
      type="button"
      className={styles.deleteButton}
      onClick={(): void => handleDeleteClick({ fileId: id, fileName: name })}
    >
      <img src={DeleteIcon} alt="delete button" />
    </button>
  )) ||
  null;

interface NextProps {
  nextSlide: () => void;
}

export const Next = ({ nextSlide }: NextProps): JSX.Element => (
  <button onClick={nextSlide} className={styles.fileViewControlButtons} type="button">
    {'>'}
  </button>
);

interface CloseProps {
  closeFileView: () => void;
}

export const Close = ({ closeFileView }: CloseProps): JSX.Element => (
  <button onClick={closeFileView} className={styles.closeFileViewButton} type="button">
    <img src={CloseIcon} alt="close" className={styles.closeIcon} />
  </button>
);

interface PrevProps {
  prevSlide: () => void;
}

export const Prev = ({ prevSlide }: PrevProps): JSX.Element => (
  <button className={styles.fileViewControlButtons} onClick={prevSlide} type="button">
    {'<'}
  </button>
);
